// @mui material components
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'

// @mui icons
// import FacebookIcon from '@mui/icons-material/Facebook'
// import TwitterIcon from '@mui/icons-material/Twitter'
// import InstagramIcon from '@mui/icons-material/Instagram'

// Material Dashboard 2 React components
import MDBox from 'components/MDBox'
import localforage from 'localforage'
// Material Dashboard 2 React example components
import ProfileInfoCard from 'examples/Cards/InfoCards/ProfileInfoCard'
// import ProfilesList from 'examples/Lists/ProfilesList'

import { useUserInfo } from 'context/user'

import burceMars from 'assets/images/bruce-mars.jpg'

// Overview page components
import MDAvatar from 'components/MDAvatar'
import MDTypography from 'components/MDTypography'
import { Box, Button, Icon, TextField, Typography } from '@mui/material'
import { useLogout } from 'hook/auth'
import { useEffect, useState } from 'react'
import env from 'config'
import { useAppServices } from 'hook/services'
function Canny() {
  const [user_details, setuser_details] = useState('')
  const AppService = useAppServices()
  const [superAdminSetting,setSuperAdminSetting] = useState("");
  const [cannyAppId, setCannyAppId] = useState("")
  const [user] = useUserInfo()
  const Logout = useLogout()
  const BASE_URL = `${env.API_URL}/v1`

  useEffect(async () => {
    const localBrand = await localforage.getItem('user')
    var axios = require('axios')

    axios
      .get(
        BASE_URL +
          '/snapshot/agency/location_settings/' +
          localBrand.agency_id +
          '/' +
          localBrand._id
      )
      .then(async function (response) {
        setuser_details(response.data.data.user)
      })
      .catch(function (error) {
        console.log(error)
      })
  }, [])

  const GetSuperAdminSetting = async () => {
      const { response } = await AppService.superadmin.GET();
      if(response){
           setSuperAdminSetting(response?.data)
           setCannyAppId(response?.data?.canny_app_id || "");
      }
  }

  useEffect(() => {
      GetSuperAdminSetting()
  },[])

  const handleUpdate = async () => {
    const payload = {
      _id:superAdminSetting?._id,
      canny_app_id: cannyAppId,
    }

    try {
      const { response } = await AppService.superadmin.UpdateCanny({ payload })
      console.log('Updated successfully', response)
    } catch (err) {
      console.error('Update failed', err)
    }
  }
  return (
    <>
      <MDBox mb={2} />

      <Grid container spacing={3} alignItems="center">
        <Grid item ml="auto">
          <MDBox onClick={Logout} sx={{ cursor: 'pointer' }} display="flex" alignItems="center">
            <Icon>logout</Icon>
            <MDTypography
              ml={1}
              mr={5}
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Logout
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>

      <MDBox mt={5} mb={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} xl={6}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}
            >
              {/* <Divider orientation="vertical" sx={{ ml: -2, mr: 2 }} /> */}

              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              }}>
                <Typography variant="subtitle2" fontWeight="medium" mb={1}>
                  Canny App ID
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Enter your Canny App ID"
                  value={cannyAppId}
                  onChange={(e) => setCannyAppId(e.target.value)}
                />
                 <Button
                variant="contained"
                sx={{
                  ml: 2,
                  height: '40px',
                  whiteSpace: 'nowrap',
                  backgroundColor: '#fff',
                  color: 'primary.main',
                  border: '1px solid',
                  borderColor: 'primary.main',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
                onClick={handleUpdate}
              >
                Update
              </Button>
              </Box>
             

              {/* <Divider orientation="vertical" sx={{ ml: 2 }} /> */}
            </Box>
          </Grid>
        </Grid>
      </MDBox>
    </>
  )
}

export default Canny
